import { InlineSvg } from 'components/svg';
import { useDebounce } from 'hooks/use-debounce';
import { FC, useEffect, useState } from 'react';

type Props = {
  currentValue: string;
  placeholder: string;
  onTextChange: (val?: string) => void;
};

export const SearchComponent: FC<Props> = ({ currentValue, placeholder, onTextChange }) => {
  const [isFirstCall, setFirstCall] = useState<boolean>(false);
  const [searchTerm, setSearchTerm] = useState<string>('');

  useEffect(() => {
    if (searchTerm != currentValue) {
      setSearchTerm(currentValue ?? '');
    }
  }, [currentValue]);
  // Debounce search term so that it only gives us latest value ...
  // ... if searchTerm has not been updated within last 500ms.
  // The goal is to only have the API call fire when employee stops typing ...
  // ... so that we aren't hitting our API rapidly.
  const debouncedSearchTerm = useDebounce(searchTerm, 500);
  // Effect for API call
  useEffect(
    () => {
      if (isFirstCall && debouncedSearchTerm !== undefined && searchTerm !== undefined) {
        onTextChange(searchTerm);
      }

      setFirstCall(true);
    },
    [debouncedSearchTerm] // Only call effect if debounced search term changes
    // More details about useDebounce: https://usehooks.com/useDebounce/
  );

  return (
    <div className="d-flex align-items-center position-relative w-100">
      <InlineSvg path="/media/icons/duotune/general/gen021.svg" className="svg-icon-2 position-absolute ms-3" />
      <input
        type="text"
        data-kt-employee-table-filter="search"
        className="form-control form-control-solid ps-12"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
    </div>
  );
};
